import React from "react";
import { Button } from "@purpur/button";
import { IconSearch } from "@purpur/icon/search";
import c from "classnames/bind";

import styles from "./search-field-button.module.scss";

type Props = {
  ["data-testid"]?: string;
  disabled?: boolean;
  iconOnly?: boolean;
  label: string;
  type?: "submit" | "button";
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const cx = c.bind(styles);
const rootClassName = "purpur-search-field-button";

export const SearchFieldButton = ({
  ["data-testid"]: dataTestid,
  disabled,
  iconOnly,
  label,
  type = "submit",
  onClick,
}: Props) => {
  const buttonProps = {
    className: cx(rootClassName, {
      [`${rootClassName}--icon-only`]: iconOnly,
    }),
    disabled,
    ["data-testid"]: dataTestid,
    onClick,
  };

  if (iconOnly) {
    return (
      <Button {...buttonProps} aria-label={label} iconOnly size="sm" type={type} variant="primary">
        <IconSearch size="xs" />
      </Button>
    );
  }

  return (
    <Button {...buttonProps} size="sm" type={type} variant="primary">
      {label}
    </Button>
  );
};
